import { useEffect, useState } from 'react';
import { api } from '../api';
export async function createWorker(input) {
    await api.post('/workers', input);
}
export async function updateWorker(id, input) {
    await api.put(`/workers/${id}`, input);
}
export async function deleteWorker(id) {
    await api.delete(`/workers/${id}`);
}
/** Prueba en vivo la conectividad de un worker (POST /workers/:id/validate). */
export async function validateWorker(id) {
    const r = await api.post(`/workers/${id}/validate`);
    return r.data;
}
/** Mide el pool (POST /workers/benchmark). Síncrono: con kaggle tarda minutos. */
export async function benchmarkPool(work = 64) {
    const r = await api.post('/workers/benchmark', { work });
    return r.data;
}
/** Emulador de potencia unificada + asesor (GET /workers/capacity?work=N).
 *  Requiere haber ejecutado benchmark antes (si no, 409). */
export async function getCapacity(work = 1024) {
    const r = await api.get('/workers/capacity', { params: { work } });
    return r.data;
}
/** Lee el pool de workers del usuario (GET /workers). Los secretos nunca
 *  llegan al cliente: sólo `secretFields` con sus nombres. */
export function useWorkers() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tick, setTick] = useState(0);
    useEffect(() => {
        let alive = true;
        setLoading(true);
        api
            .get('/workers')
            .then((r) => {
            if (alive) {
                setData(r.data);
                setError(null);
            }
        })
            .catch((e) => {
            if (alive)
                setError(e instanceof Error ? e.message : String(e));
        })
            .finally(() => {
            if (alive)
                setLoading(false);
        });
        return () => {
            alive = false;
        };
    }, [tick]);
    return {
        workers: data?.workers ?? [],
        total: data?.total ?? 0,
        loading,
        error,
        refresh: () => setTick((n) => n + 1),
    };
}
/** Lee el pool efectivo que usa /jobs/orchestrate: workers del usuario +
 * flota viva auto-publicada (Colab/laptops por túnel). */
export function useWorkerPool() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tick, setTick] = useState(0);
    useEffect(() => {
        let alive = true;
        setLoading(true);
        api
            .get('/workers/pool')
            .then((r) => {
            if (alive) {
                setData(r.data);
                setError(null);
            }
        })
            .catch((e) => {
            if (alive)
                setError(e instanceof Error ? e.message : String(e));
        })
            .finally(() => {
            if (alive)
                setLoading(false);
        });
        return () => {
            alive = false;
        };
    }, [tick]);
    return {
        workers: data?.workers ?? [],
        total: data?.total ?? 0,
        userTotal: data?.userTotal ?? 0,
        fleetTotal: data?.fleetTotal ?? 0,
        loading,
        error,
        refresh: () => setTick((n) => n + 1),
    };
}
/** Prueba la ejecución de un núcleo/wrapper en el background (POST /workers/test-core). */
export async function testCore(core) {
    const r = await api.post('/workers/test-core', { core });
    return r.data;
}
